import React from 'react';
import SegmentPageTemplate from '../components/SegmentPageTemplate';
import segmentConfigs from '../config/segmentConfigs';

const LocacaoHospital = () => {
  return <SegmentPageTemplate {...segmentConfigs.hospital} />;
};

export default LocacaoHospital;